module.exports = __webpack_public_path__ + "static/img/manual_ja_12.287e46e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_12.png
// module id = 7VYo
// module chunks = 4